import {
  Box,
  FormControl,
  // InputLabel,
  // MenuItem,
  // Select,
  TextField,
  Typography,
  useTheme,
} from '@material-ui/core';
import DatePicker from '@material-ui/lab/DatePicker';
import TreeItem, { useTreeItem } from '@material-ui/lab/TreeItem';
import clsx from 'clsx';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { Controller, useForm } from 'react-hook-form';
// import { channelMapList } from '@/constants';
import { useIntl } from 'umi';
import SearchConditionStyled from './SearchConditionStyled';

const CustomContent = React.forwardRef(function CustomContent(props, ref) {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
  } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const handleMouseDown = (event) => {
    preventSelection(event);
  };

  const handleExpansionClick = (event) => {
    handleExpansion(event);
  };

  const handleSelectionClick = (event) => {
    handleSelection(event);
  };

  return (
    <div
      ref={ref}
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      style={{ height: '39px', width: '100%' }}
    >
      <div className={classes.iconContainer} onClick={handleExpansionClick}>
        {iconProp || expansionIcon || displayIcon}
      </div>
      <Typography
        component="div"
        className={classes.label}
        onClick={(e) => handleSelectionClick(e)}
      >
        {label}
      </Typography>
    </div>
  );
});

const CustomTreeItem = (props) => {
  const { id, parentName, children, rest } = props;
  return (
    <TreeItem
      {...rest}
      ContentComponent={CustomContent}
      nodeId={id}
      label={parentName}
    >
      {(children || []).map((item, index) => (
        <CustomTreeItem key={index} {...item} />
      ))}
    </TreeItem>
  );
};

const SearchCondition = (props) => {
  const {
    handleSearch,
    setDate,
    date,
    period,
    // setPeriod,
    // setChannelData,
    channelData,
  } = props;

  const theme = useTheme();
  const { formatMessage } = useIntl();
  // eslint-disable-next-line no-unused-vars
  const { handleSubmit, control } = useForm({
    defaultValues: {},
  });

  // const searchDate = useSelector((state) => state.bhc.date);
  // const { startDate, endDate } = searchDate;

  const [dateValue, setDateValue] = useState();
  const dateRef = useRef();
  // const periodRef = useRef();
  // const channelRef = useRef();

  // const newStartDate = useMemo(() => {
  //   if (startDate) {
  //     if (startDate === endDate) {
  //       return dayjs(startDate).format('YYYY-MM-DD');
  //     }
  //     return dayjs(startDate).format('YYYY-MM');
  //   }
  //   return dayjs(new Date()).format('YYYY-MM-01');
  // }, [startDate]);

  // const newEndDate = useMemo(() => {
  //   if (startDate === endDate) {
  //     if (dayjs(endDate).month() === 1) {
  //       return dayjs(dayjs(endDate).add(27, 'day')).format('YYYY-MM-DD');
  //     }
  //     return dayjs(dayjs(endDate).add(29, 'day')).format('YYYY-MM-DD');
  //   }
  //   return dayjs(endDate).format('YYYY-MM');
  // }, [endDate]);

  // Period下拉框
  // eslint-disable-next-line no-unused-vars
  const PeriodListData = [
    {
      id: 0,
      name: 'MTD',
      value: 'MTD',
    },
    {
      id: 1,
      name: 'YTD',
      value: 'YTD',
    },
    // {
    //   id: 2,
    //   name: 'R12',
    //   value: 'R12',
    // },
  ];

  //查询
  const handleSubmitSuccess = (values) => {
    handleSearch(values);
  };

  const dateClick = () => {
    window.NE_DAWN.trigger(dateRef.current, {
      event: '_ec', // 事件名
      params: {
        statisticalMonth: dayjs(date).format('YYYYMM'),
        // period
        period: period,
        channel: channelData,
      }, // 事件公参
    });
  };

  useEffect(() => {
    dateValue && dateRef.current.click();
  }, [dateValue]);

  return (
    <SearchConditionStyled theme={theme}>
      <Box className="update-time-wrap">
        <span className="time-content">
          {/* 该报表的更新周期为T+1，次日可查到昨日及更久之前的结果 */}
          {formatMessage({ id: 'report.health.n01.lbl01' })}
        </span>
      </Box>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="card-content-wrap">
          <FormControl className="date-wrap" style={{ width: 300 }}>
            <DatePicker
              sx={{ color: '#1D8FC0' }}
              className="date"
              views={['year', 'month']}
              label={formatMessage({ id: 'report.health.n02.rdo01' })}
              // minDate={new Date(newStartDate)}
              // maxDate={new Date(newEndDate)}
              openTo="month"
              value={date}
              onChange={(newValue) => {
                setDateValue(newValue);
                setDate(newValue);
              }}
              // onMonthChange={(newValue) => {
              //   setDate(newValue);
              // }}
              renderInput={(params) => (
                <TextField
                  sx={{ color: '#1D8FC0' }}
                  variant="standard"
                  {...params}
                  helperText={null}
                />
              )}
            />
            <Box
              data-log={JSON.stringify({
                oid: 'btn_report_center_brand_health_check_details_statistic_month_dropdown',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={dateRef}
              display="none"
              onClick={dateClick}
            ></Box>
          </FormControl>
          {/* 周期 */}
          {/* <FormControl variant="standard" className="gender single-select">
            <InputLabel sx={{ fontFamily: 'SourceHanSansCNRegular' }}>
              {formatMessage({ id: 'report.health.n02.rdo02' })}
            </InputLabel>
            <Controller
              render={(rpr) => (
                <Select
                  ref={periodRef}
                  data-log={JSON.stringify({
                    oid: 'btn_report_center_brand_health_check_details_cycle_dropdown',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  onChange={(e) => {
                    setPeriod(e.target.value);
                    window.NE_DAWN.trigger(periodRef.current, {
                      event: '_ec', // 事件名
                      params: {
                        statisticalMonth: dayjs(date).format('YYYYMM'),
                        // period
                        period: e.target.value,
                        channel: channelData,
                      }, // 事件公参
                    });
                    return rpr.onChange(e.target.value);
                  }}
                  value={rpr.value ?? period}
                >
                  {PeriodListData?.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.value}
                      name={item.name}
                      sx={{
                        color: '#1D8FC0',
                        fontFamily: 'CenturyGothic-Bold, Century Gothic',
                      }}
                    >
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              )}
              label=""
              name="Period"
              control={control}
              defaultValue={PeriodListData[0].value}
            />
          </FormControl> */}
          {/* 渠道 */}
          {/* <FormControl variant="standard" className="gender single-select">
            <InputLabel sx={{ fontFamily: 'SourceHanSansCNRegular' }}>
              {formatMessage({ id: 'report.health.n02.rdo03' })}
            </InputLabel>

            <Controller
              render={(rpr) => (
                <Select
                  ref={channelRef}
                  data-log={JSON.stringify({
                    oid: 'btn_report_center_brand_health_check_details_channel_dropdown',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  onChange={(e) => {
                    setChannelData(e.target.value);
                    window.NE_DAWN.trigger(channelRef.current, {
                      event: '_ec', // 事件名
                      params: {
                        statisticalMonth: dayjs(date).format('YYYYMM'),
                        // period
                        period,
                        channel: channelData,
                      }, // 事件公参
                    });
                    return rpr.onChange(e.target.value);
                  }}
                  value={rpr.value ?? channelData}
                >
                  {channelMapList.map((item) => (
                    <MenuItem key={item.id} value={item.id} name={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
              label="channel"
              name="channel"
              control={control}
              defaultValue={channelData}
            />
          </FormControl> */}
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
